import { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import ExperienceSection from '../components/ExperienceSection';
import { Link } from "react-router-dom";

export default function Page() {
  useEffect(() => {
    if (typeof window !== "undefined" && window.$) {
      const $ = window.$;

      // 1. Simple Counter Up
      if ($(".number1").length) {
        $.fn.$SimpleCounter = function (options) {
          var settings = $.extend({ start: 0, end: 100, easing: "swing", duration: 400, complete: "" }, options);
          var thisElement = $(this);
          $({ count: settings.start }).animate(
            { count: settings.end },
            {
              duration: settings.duration,
              easing: settings.easing,
              step: function () {
                var mathCount = Math.ceil(this.count);
                thisElement.text(mathCount);
              },
              complete: settings.complete,
            }
          );
        };
        $(".number1").$SimpleCounter({ end: 500, duration: 3000 });
        $(".number2").$SimpleCounter({ end: 350, duration: 3000 });
        $(".number3").$SimpleCounter({ end: 8, duration: 2000 });
        $(".number4").$SimpleCounter({ end: 15, duration: 2500 });
      }

      // 2. Search block
      $(".search-block").off("click").on("click", function () {
        $(".search-box").fadeToggle("slow").css({ top: "61px" });
        $(".search-block .fa").toggleClass("fa-times fa-search").addClass("fa-search");
      });

      // 3. GLightbox
      if ($(".btn_gallery").length && typeof GLightbox !== "undefined") {
        const galleryLightbox = GLightbox({ selector: ".btn_gallery" });
      }

      // 4. Hero Swiper
      if ($(".hero-slider").length && typeof Swiper !== "undefined") {
        const sliderItems = document.querySelectorAll(".slider-item");
        const container = document.querySelectorAll(".slide_img_container");
        const slice = 10;

        const swiper99 = new Swiper(".hero-slider", {
          direction: "horizontal",
          loop: true,
          autoplay: { delay: 5000, disableOnInteraction: false },
          speed: 2000,
          pagination: { el: ".swiper-pagination", type: "bullets", clickable: true },
          navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
          on: {
            slideChange: function () {
              sliderItems.forEach((item) => item.classList.remove("animate"));
              sliderItems.forEach((item) => setTimeout(() => $(item).addClass("animate"), 1000));
              splitImage("", slice, slice, container);
            },
          },
        });

        swiper99.on("slideChange", function () {
          updatePagination(this);
        });

        function updatePagination(swiper) {
          if (!swiper.slides || swiper.slides.length === 0) return;
          var currentSlide = swiper.slides[swiper.activeIndex];
          if (!currentSlide) return;
          var nextSlide = swiper.slides[(swiper.activeIndex + 1) % swiper.slides.length];
          var prevSlide = swiper.slides[(swiper.activeIndex - 1 + swiper.slides.length) % swiper.slides.length];

          var containerEl = currentSlide.querySelector(".slide_img_container");
          var currentImageSrc = containerEl ? containerEl.getAttribute("data-src") : "";
          var nextContainerEl = nextSlide.querySelector(".slide_img_container");
          var nextImageSrc = nextContainerEl ? nextContainerEl.getAttribute("data-src") : "";
          var prevContainerEl = prevSlide.querySelector(".slide_img_container");
          var prevImageSrc = prevContainerEl ? prevContainerEl.getAttribute("data-src") : "";

          var paginationBullets = document.querySelectorAll(".swiper-pagination-bullet");
          if (paginationBullets.length > swiper.activeIndex) {
            paginationBullets[swiper.activeIndex].style.backgroundImage = "url(" + currentImageSrc + ")";
          }
          var prevIndex = (swiper.activeIndex - 1 + swiper.slides.length) % swiper.slides.length;
          if (paginationBullets.length > prevIndex) {
            paginationBullets[prevIndex].style.backgroundImage = "url(" + prevImageSrc + ")";
          }
          var nextIndex = (swiper.activeIndex + 1) % swiper.slides.length;
          if (paginationBullets.length > nextIndex) {
            paginationBullets[nextIndex].style.backgroundImage = "url(" + nextImageSrc + ")";
          }
        }

        function splitImage(imageUrl, numCols, numRows, container) {
          container.forEach((item) => {
            item.innerHTML = "";
            item.classList.remove("bg-animate-duration", "bg-animate");
            for (let y = 0; y < numRows; y++) {
              for (let x = 0; x < numCols; x++) {
                const div = document.createElement("div");
                div.className = "animation-part";
                div.style.backgroundImage = `url('${imageUrl}')`;
                const posX = x * 100;
                const posY = y * 100;
                div.style.backgroundPosition = `-${posX}% -${posY}%`;
                item.appendChild(div);
              }
            }
            setTimeout(() => {
              item.classList.add("bg-animate-duration", "bg-animate");
            }, 2000);
          });
        }

        updatePagination(swiper99);
        splitImage("", slice, slice, container);
        $(".swiper-pagination-bullet").addClass("swiper-pagination-style");
      }

      // 5. Isotope Gallery
      if ($("#portfolio-filter7").length && typeof $.fn.isotope !== "undefined") {
        var $container = $("#portfolio-filter7").isotope({
          itemSelector: ".item",
          isFitWidth: true,
        });
        $(window).resize(function () {
          $container.isotope({ columnWidth: ".col-sm-3" });
        });
        $container.isotope({ filter: "*" });
        $("#filters").off("click", "button").on("click", "button", function () {
          var filterValue = $(this).attr("data-filter");
          $container.isotope({ filter: filterValue });
          $("#filters button").removeClass("active");
          $(this).addClass("active");
        });
      }

      // 6. AOS animations
      if (typeof AOS !== "undefined") {
        AOS.init({ easing: "ease-in-out-sine" });
      }

      // 7. Mobile menu toggle handlers
      const $menuArea = $(".mobile-menu-area");
      const $hamburger = $(".mobile-menu-toggle-new-line");
      const $menuClose = $(".mobile-menu-area .mobile-menu-close");
      const $menuOverlay = $(".mobile-menu-area .mobile-menu-overlay");

      $hamburger.off("click").on("click", function () {
        $menuArea.addClass("menu-open");
        $("body").css("overflow", "hidden");
        $(".line").addClass("change");
      });

      function closeMenu() {
        $menuArea.removeClass("menu-open");
        $("body").css("overflow", "");
        $(".line").removeClass("change");
      }

      $menuClose.off("click").on("click", closeMenu);
      $menuOverlay.off("click").on("click", closeMenu);

      const wrapper = document.querySelector(".mobile-menu-area .mobile-menu-wrapper");
      if (wrapper) {
        wrapper.addEventListener("click", function (e) {
          var link = e.target.closest(".menu-item-has-children > a");
          if (link) {
            e.preventDefault();
            e.stopPropagation();
            var submenu = link.nextElementSibling;
            if (submenu) {
              submenu.classList.toggle("open");
              link.closest(".menu-item-has-children").classList.toggle("submenu-open");
            }
            return;
          }
          var navLink = e.target.closest(".mobile-menu-nav > ul > li:not(.menu-item-has-children) > a, .mobile-menu-nav .sm-submenu a");
          if (navLink) {
            closeMenu();
          }
        });
      }

      // 8. Global Quote Modal toggle handlers
      $(".get-quote-btn").off("click").on("click", function (e) {
        e.preventDefault();
        $("#quoteModal").addClass("show");
        $("body").css("overflow", "hidden");
      });
      $(".quote-modal-close, .quote-done-btn").off("click").on("click", function () {
        $("#quoteModal").removeClass("show");
        $("body").css("overflow", "");
        $("#quoteSuccess").removeClass("show");
        $("#quoteForm").show();
      });
      $("#quoteForm").off("submit").on("submit", function (e) {
        e.preventDefault();
        // simulate success
        $(this).hide();
        $("#quoteSuccess").addClass("show");
      });

      // 9. FAQ accordion
      $(".faq-block-2 .accordion-list > li > .answer").hide();
      // keep first active open
      $(".faq-block-2 .accordion-list > li.active > .answer").show();
      $(".faq-block-2 .accordion-list > li").off("click").on("click", function () {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active").find(".answer").slideUp();
        } else {
          $(".faq-block-2 .accordion-list > li.active .answer").slideUp();
          $(".faq-block-2 .accordion-list > li.active").removeClass("active");
          $(this).addClass("active").find(".answer").slideDown();
        }
        return false;
      });
    }
  }, []);

  return (
    <>

      <section className="page-hero" style={{ backgroundImage: "url('/assets/img/unsplash-1518770660439-4636190af475.jpg')" }}>
        <div className="page-hero-overlay"></div>
        <div className="container">
          <div className="page-hero-content">
            <div className="hero-service-icon"><i className="fa fa-info-circle"></i></div>
            <h1>About Callsoftbd</h1>
            <nav className="breadcrumb-nav" aria-label="breadcrumb">
              <Link to="/">Home</Link><span className="sep">/</span>
              <span className="current">About Us</span>
            </nav>
          </div>
        </div>
      </section>
      <section id="about" className="about-us-1 pt-60 pb-60">

        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/42-hexagon.svg')" }} data-aos="fade-up" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/31-star-5point.svg')" }} data-aos="fade-down" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/11-circle-basic.svg')" }} data-aos="fade-left" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/75-shield.svg')" }} data-aos="fade-right" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/95-layered-circles.svg')" }} data-aos="zoom-in" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/63-diamond.svg')" }} data-aos="zoom-out" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/83-rounded-squircle.svg')" }} data-aos="flip-left" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/89-gear.svg')" }} data-aos="flip-right" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/47-hexagon-outline.svg')" }} data-aos="flip-up" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container">
          <div className="row align-items-center flex-row-reverse">
            <div className="col-lg-6">
              <div className="ebl-data-blocks">
                <div className="comingsoon-body-item block-item" data-aos="flip-left" data-aos-delay="100">
                  <div className="subtitle subtitle_1bececf">
                    <h4>
                      <span className="subtitle-first-span"></span>
                      <span className="subtitle-middle-span">About Us</span>
                      <span className="subtitle-last-span"></span>
                    </h4>
                  </div>
                </div>
                <div className="comingsoon-body-item block-item" data-aos="flip-right" data-aos-delay="200">
                  <div className="title title_1bececf">
                    <h2>
                      <span></span>
                      <span>Company Profile</span>
                      <span></span>
                    </h2>
                  </div>
                </div>
                <div className="comingsoon-body-item block-item" data-aos="flip-left" data-aos-delay="300">
                  <div className="plain_text plain_text_1bececf">
                    <p style={{ marginBottom: "15px" }}>
                      Callsoftbd is a Bangladesh-based technology company specializing in end-to-end digital solutions, including Web &amp; App Development, UI/UX Design, Cloud &amp; DevOps, VPS &amp; Hosting, AWS &amp; Cloud Platforms, Server Management, AI &amp; Data solutions, Cybersecurity, and Migration &amp; Maintenance services.
                    </p>
                    <p>
                      We help businesses transform digitally with scalable, secure, and high-performance technology solutions. Callsoftbd operates from the Dhaka with a focus on delivering modern IT infrastructure and software solutions tailored to startups, SMEs, and enterprise-level organizations. Our team combines technical expertise with industry best practices to build reliable and future-ready digital systems.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="img-relative text-start single-img-wrapper" data-aos="flip-left" data-aos-delay="300">
                <div className="img-anim-one bg-img-effect">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <a href="#"><img src="/assets/img/unsplash-1518770660439-4636190af475.jpg"
                  alt="Callsoftbd Developer Team" /></a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Services Section */}
      <section className="core-services-section" style={{ backgroundColor: "#f8f9fc", padding: "100px 0" }}>
        <div className="container">
          <div className="row align-items-center flex-row-reverse">
            <div className="col-lg-6 mb-30" data-aos="fade-left">
              <div style={{ display: "inline-block", background: "rgba(36, 0, 168, 0.1)", color: "var(--color-primary)", width: "80px", height: "80px", lineHeight: "80px", textAlign: "center", borderRadius: "50%", fontSize: "32px", marginBottom: "20px" }}>
                <i className="fa fa-cogs"></i>
              </div>
              <h2 style={{ fontSize: "36px", fontWeight: "800", marginBottom: "30px" }}>Core Capabilities</h2>
              <ul className="common-list-ul" style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                {
                  [
                    "Web Development & Custom Applications",
                    "Mobile App Development (iOS & Android)",
                    "UI/UX Design & Prototyping",
                    "Cloud Computing & DevOps Solutions",
                    "VPS, Hosting & Server Management",
                    "AWS & Cloud Infrastructure Setup",
                    "AI & Data Solutions",
                    "Cybersecurity Solutions",
                    "System Migration & Maintenance"
                  ].map((service, idx) => (
                    <li key={idx} style={{ display: "flex", alignItems: "flex-start", gap: "15px" }}>
                      <i className="fa fa-check-circle" style={{ color: "var(--color-primary)", marginTop: "4px", fontSize: "20px" }}></i>
                      <span style={{ color: "#555", fontSize: "16px", lineHeight: "1.6" }}>{service}</span>
                    </li>
                  ))
                }
              </ul>
            </div>
            <div className="col-lg-6 mb-30 text-center" data-aos="fade-right">
              <img src="/assets/img/unsplash-1454165804606-c3d57bc86b40.jpg" alt="Core Services" style={{ borderRadius: "12px", boxShadow: "0 10px 30px rgba(0,0,0,0.1)", maxWidth: "100%", height: "auto" }} />
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section" style={{ backgroundColor: "#ffffff", padding: "100px 0" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-30" data-aos="fade-right">
              <div style={{ display: "inline-block", background: "rgba(36, 0, 168, 0.1)", color: "var(--color-primary)", width: "80px", height: "80px", lineHeight: "80px", textAlign: "center", borderRadius: "50%", fontSize: "32px", marginBottom: "20px" }}>
                <i className="fa fa-bullseye"></i>
              </div>
              <h2 style={{ fontSize: "36px", fontWeight: "800", marginBottom: "20px" }}>Our Mission</h2>
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "18px" }}>
                To empower businesses with innovative, secure, and scalable digital solutions that enhance performance, improve efficiency, and accelerate digital transformation.
              </p>
            </div>
            <div className="col-lg-6 mb-30 text-center" data-aos="fade-left">
              <img src="/assets/img/unsplash-1518770660439-4636190af475.jpg" alt="Our Mission" style={{ borderRadius: "12px", boxShadow: "0 10px 30px rgba(0,0,0,0.1)", maxWidth: "100%", height: "auto" }} />
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="vision-section" style={{ backgroundColor: "#f8f9fc", padding: "100px 0" }}>
        <div className="container">
          <div className="row align-items-center flex-row-reverse">
            <div className="col-lg-6 mb-30" data-aos="fade-left">
              <div style={{ display: "inline-block", background: "rgba(255, 78, 0, 0.1)", color: "#ff4e00", width: "80px", height: "80px", lineHeight: "80px", textAlign: "center", borderRadius: "50%", fontSize: "32px", marginBottom: "20px" }}>
                <i className="fa fa-eye"></i>
              </div>
              <h2 style={{ fontSize: "36px", fontWeight: "800", marginBottom: "20px" }}>Our Vision</h2>
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "18px" }}>
                To become a leading global technology partner recognized for excellence in software engineering, cloud infrastructure, cybersecurity, and intelligent digital solutions.
              </p>
            </div>
            <div className="col-lg-6 mb-30 text-center" data-aos="fade-right">
              <img src="/assets/img/unsplash-1507146426996-ef05306b995a.jpg" alt="Our Vision" style={{ borderRadius: "12px", boxShadow: "0 10px 30px rgba(0,0,0,0.1)", maxWidth: "100%", height: "auto" }} />
            </div>
          </div>
        </div>
      </section>

      {/* Goals Section */}
      <section className="goals-section" style={{ backgroundColor: "#ffffff", padding: "100px 0" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-30" data-aos="fade-right">
              <div style={{ display: "inline-block", background: "rgba(0, 184, 148, 0.1)", color: "#00b894", width: "80px", height: "80px", lineHeight: "80px", textAlign: "center", borderRadius: "50%", fontSize: "32px", marginBottom: "20px" }}>
                <i className="fa fa-flag-checkered"></i>
              </div>
              <h2 style={{ fontSize: "36px", fontWeight: "800", marginBottom: "30px" }}>Our Goals</h2>
              <ul className="common-list-ul" style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                {
                  [
                    "Deliver high-quality, scalable web and mobile applications",
                    "Provide secure and reliable cloud & hosting infrastructure",
                    "Enable businesses with AI-driven and data-powered solutions",
                    "Strengthen cybersecurity for digital businesses",
                    "Ensure seamless system migration and ongoing maintenance support",
                    "Achieve customer satisfaction through innovation and service excellence"
                  ].map((goal, idx) => (
                    <li key={idx} style={{ display: "flex", alignItems: "flex-start", gap: "15px" }}>
                      <i className="fa fa-check-circle" style={{ color: "#00b894", marginTop: "4px", fontSize: "20px" }}></i>
                      <span style={{ color: "#555", fontSize: "16px", lineHeight: "1.6" }}>{goal}</span>
                    </li>
                  ))
                }
              </ul>
            </div>
            <div className="col-lg-6 mb-30 text-center" data-aos="fade-left">
              <img src="/assets/img/unsplash-1551288049-bebda4e38f71.jpg" alt="Our Goals" style={{ borderRadius: "12px", boxShadow: "0 10px 30px rgba(0,0,0,0.1)", maxWidth: "100%", height: "auto" }} />
            </div>
          </div>
        </div>
      </section>

      {/* Objectives Section */}
      <section className="objectives-section" style={{ backgroundColor: "#f8f9fc", padding: "100px 0" }}>
        <div className="container">
          <div className="row align-items-center flex-row-reverse">
            <div className="col-lg-6 mb-30" data-aos="fade-left">
              <div style={{ display: "inline-block", background: "rgba(225, 112, 85, 0.1)", color: "#e17055", width: "80px", height: "80px", lineHeight: "80px", textAlign: "center", borderRadius: "50%", fontSize: "32px", marginBottom: "20px" }}>
                <i className="fa fa-list-alt"></i>
              </div>
              <h2 style={{ fontSize: "36px", fontWeight: "800", marginBottom: "30px" }}>Our Objectives</h2>
              <ul className="common-list-ul" style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                {
                  [
                    "Develop customized software solutions based on client requirements",
                    "Maintain 99.9% uptime for hosting and server services",
                    "Implement industry-standard security frameworks and practices",
                    "Optimize cloud infrastructure for performance and cost efficiency",
                    "Provide continuous technical support and system upgrades",
                    "Expand service offerings across global markets"
                  ].map((obj, idx) => (
                    <li key={idx} style={{ display: "flex", alignItems: "flex-start", gap: "15px" }}>
                      <i className="fa fa-check-circle" style={{ color: "#e17055", marginTop: "4px", fontSize: "20px" }}></i>
                      <span style={{ color: "#555", fontSize: "16px", lineHeight: "1.6" }}>{obj}</span>
                    </li>
                  ))
                }
              </ul>
            </div>
            <div className="col-lg-6 mb-30 text-center" data-aos="fade-right">
              <img src="/assets/img/unsplash-1563986768609-322da13575f3.jpg" alt="Our Objectives" style={{ borderRadius: "12px", boxShadow: "0 10px 30px rgba(0,0,0,0.1)", maxWidth: "100%", height: "auto" }} />
            </div>
          </div>
        </div>
      </section>

      <section className="skills-1 pt-60 pb-60">

        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/12-circle-outline.svg')" }} data-aos="fade-right" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/85-wave.svg')" }} data-aos="zoom-in" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/64-diamond-outline.svg')" }} data-aos="zoom-out" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/87-trophy.svg')" }} data-aos="flip-left" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/96-hexagon-badge.svg')" }} data-aos="flip-right" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/20-circle-ring.svg')" }} data-aos="flip-up" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/48-octagon-outline.svg')" }} data-aos="flip-down" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/40-star-sparkle.svg')" }} data-aos="rotate-left" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/50-hexagon-flat.svg')" }} data-aos="rotate-right" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="ebl-data-blocks">
                <div className="comingsoon-body-item block-item" data-aos="flip-left" data-aos-delay="100">
                  <div className="subtitle subtitle_1bececf">
                    <h4>
                      <span className="subtitle-first-span"></span>
                      <span className="subtitle-middle-span">Our Expertise</span>
                      <span className="subtitle-last-span"></span>
                    </h4>
                  </div>
                </div>
                <div className="comingsoon-body-item block-item" data-aos="flip-right" data-aos-delay="200">
                  <div className="title title_1bececf">
                    <h2>
                      <span></span>
                      <span>Industry-Leading Technical Expertise</span>
                      <span></span>
                    </h2>
                  </div>
                </div>
                <div className="comingsoon-body-item block-item" data-aos="flip-left" data-aos-delay="300">
                  <div className="plain_text plain_text_1bececf">
                    <p>
                      Our technical team holds certifications from top cloud providers and technology partners,
                      delivering high-availability solutions for complex systems and enterprise web architectures.
                    </p>
                  </div>
                </div>
                <div className="comingsoon-body-item block-item" data-aos="flip-right" data-aos-delay="400">
                  <div className="skills_list">
                    <ul className="common-list-ul">
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>Web &amp; App Development</h5>
                          <h6>95%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "95%" }} aria-valuenow="95"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>Cloud &amp; DevOps</h5>
                          <h6>92%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "92%" }} aria-valuenow="92"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>UI/UX Product Design</h5>
                          <h6>90%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "90%" }} aria-valuenow="90"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>VPS &amp; Cloud Platforms</h5>
                          <h6>93%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "93%" }} aria-valuenow="93"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>Server Management</h5>
                          <h6>91%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "91%" }} aria-valuenow="91"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>AI &amp; Data Solutions</h5>
                          <h6>87%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "87%" }} aria-valuenow="87"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>Cybersecurity Audits</h5>
                          <h6>94%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "94%" }} aria-valuenow="94"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>System Migration</h5>
                          <h6>89%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "89%" }} aria-valuenow="89"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="img-relative text-start single-img-wrapper" data-aos="flip-left" data-aos-delay="300">
                <div className="img-anim-one bg-img-effect">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <a href="#"><img src="/assets/img/unsplash-1498050108023-c5249f4df085.jpg"
                  alt="Callsoftbd UI/UX Design &amp; Development" /></a>
              </div>
            </div>
          </div>
        </div>
      </section>





      <ExperienceSection />

      <section className="why-choose-us pt-60 pb-60">

        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/95-layered-circles.svg')" }} data-aos="fade-right" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/83-rounded-squircle.svg')" }} data-aos="zoom-in" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/11-circle-basic.svg')" }} data-aos="zoom-out" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/63-diamond.svg')" }} data-aos="flip-left" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/96-hexagon-badge.svg')" }} data-aos="flip-right" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/75-shield.svg')" }} data-aos="flip-up" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/50-hexagon-flat.svg')" }} data-aos="flip-down" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/89-gear.svg')" }} data-aos="rotate-left" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/48-octagon-outline.svg')" }} data-aos="rotate-right" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container">
          <div className="section-header">
            <div className="comingsoon-body-item block-item mb-2 text-center" data-aos="aos-blockRubberBand">
              <div className="subtitle subtitle_1bececf">
                <h4>
                  <span className="subtitle-first-span"></span>
                  <span className="subtitle-middle-span">Why Choose Us</span>
                  <span className="subtitle-last-span"></span>
                </h4>
              </div>
            </div>
            <div className="comingsoon-body-item block-item mb-2 text-center" data-aos="aos-blockRubberBand">
              <div className="title title_1bececf">
                <h2>
                  <span></span>
                  <span>What Makes Tech Zone Different</span>
                  <span></span>
                </h2>
              </div>
            </div>
            <div className="comingsoon-body-item block-item mb-4 text-center" data-aos="aos-blockRubberBand">
              <div className="plain_text plain_text_1bececf">
                <p>
                  Discover why leading businesses across the Bangladesh and whole worldtrust Callsoftbd for their critical IT products and services.
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            {
              [
                { title: "All-in-One IT Partner", icon: "fa-cubes", color: "#6c5ce7", text: "From development to cloud and security under one roof" },
                { title: "Experienced Technical Team", icon: "fa-users-cog", color: "#00b894", text: "Skilled engineers in modern technologies and platforms" },
                { title: "Scalable Solutions", icon: "fa-chart-line", color: "#0984e3", text: "Built to grow with your business needs" },
                { title: "Security First Approach", icon: "fa-shield-alt", color: "#d63031", text: "Strong focus on data protection and cybersecurity" },
                { title: "Cloud Expertise", icon: "fa-cloud", color: "#00cec9", text: "AWS, VPS, and enterprise-grade cloud solutions" },
                { title: "Fast Delivery & Support", icon: "fa-shipping-fast", color: "#fdcb6e", text: "Agile development with responsive technical support" },
                { title: "Customized Solutions", icon: "fa-cogs", color: "#e17055", text: "Tailor-made systems designed for your business goals" }
              ].map((item, idx) => (
                <div key={idx} className="col-lg-4 col-md-6 mb-30" data-aos="fade-up" data-aos-delay={(idx + 1) * 100}>
                  <div style={{
                    background: "#fff",
                    padding: "30px",
                    borderRadius: "12px",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
                    height: "100%",
                    transition: "transform 0.3s ease",
                    border: "1px solid #f4f4f4",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start"
                  }}>
                    <div style={{
                      color: item.color,
                      fontSize: "32px",
                      marginBottom: "20px",
                      background: `${item.color}15`,
                      width: "60px",
                      height: "60px",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <i className={`fa ${item.icon}`}></i>
                    </div>
                    <h4 style={{ fontSize: "20px", fontWeight: "700", marginBottom: "15px", color: "#333" }}>{item.title}</h4>
                    <p style={{ color: "#666", marginBottom: 0, lineHeight: "1.6" }}>{item.text}</p>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </section>






    </>
  );
}
